import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';
import {UmpireComponent} from '../umpire-component/umpire-component';
import {UmpireMatchPredictorRanking} from '../umpire-match-predictor-ranking';

export interface UmpireComponentMatchPredictorRanking
  extends UmpireComponent<UmpireComponentTypeEnum.MATCH_PREDICTOR_RANKING> {
  match_predictor_ranking: UmpireMatchPredictorRanking;
  match_predictor_ranking_id: string;
}
